import axios from "axios";

const AUTH_DICTIONARIES = import.meta.env.VITE_AUTH_DICTIONARIES;

export function GetAllArlService(token, page, query, pagination) {
  return new Promise(async (resolve, reject) => {
    try {
      console.log("Query from datagrid", query);
      let url;
      if (query === "") {
        console.log("URL without params inside");
        url = `${AUTH_DICTIONARIES}/api/general/v1/arl?page=${page}&pagination=${pagination}`;
      } else {
        console.log("URL with params inside", query);
        url = `${AUTH_DICTIONARIES}/api/general/v1/arl?${query}&page=${page}&pagination=${pagination}`;
      }
      const response = await axios.get(url, {
        headers: {
          "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
          Authorization: `Bearer ${token}`,
        }
      });
      // console.log("request from service getSuperadmins:", response.data);
      resolve(response.data);
    } catch (error) {
      reject(error);
    }
  });
}
